autoslash.createNamespace("autoslash.timepicker");
autoslash.register(autoslash.timepicker);

autoslash.timepicker.initialize = function (element) {
    "use strict";
    element.find("[data-autoslash-timepicker]").each(function () {
        var input = $(this);
        var step = $(this).data("autoslash-timepicker-step");
        var forceRound = $(this).data("autoslash-timepicker-forceround");
        var scrollDefault = $(this).data("autoslash-timepicker-scrolldefault");
        var dropDownCssClass = $(this).data("autoslash-timepicker-dropdowncss");
        input.timepicker({
            forceRoundTime: forceRound,
            step: step,
            scrollDefault: scrollDefault,
            className: dropDownCssClass,
            timeFormat: function(date) {
                //Hour
                var hour = date.getHours() % 12;
                hour = (hour === 0) ? "12" : hour;

                //Minutes
                var minutes = date.getMinutes();
                minutes = (minutes > 9) ? minutes : "0" + minutes;

                //AM/PM
                var amPm = (date.getHours() > 11) ? "pm" : "am";

                var result = hour + ":" + minutes + amPm;
                if (result == "12:00pm") return "Noon";
                if (result == "12:00am") return "Midnight";
                return result;
            }
        });
    });

    element.find("[data-autoslash-timepicker-icon]").each(function () {
        $(this).css("cursor", "pointer");
        var elementId = $(this).data("autoslash-timepicker-icon");
        $(this).click(function () {
            var element = $("#" + elementId);
            if (!element.is(':disabled')) {
                element.timepicker("show");
            }
        });
    });
}

// mobiscroll version

autoslash.createNamespace("autoslash.timepicker2");
autoslash.register(autoslash.timepicker2);

autoslash.timepicker2.initialize = function (element) {
    "use strict";

    function applyMidnightHelper(input) {
        var val = (input.val() || "").trim();
        var helper = input.closest(".input-group").find(".time-helper-message");

        if (val === "Midnight") {
            helper
                .html("<span class='icon'>⚠</span> Midnight is the very beginning of the selected date.")
                .addClass("active");
        } else {
            helper.html("").removeClass("active");
        }
    }

    element.find("[data-autoslash-timepicker2]").each(function () {
        var input = $(this);
        var step = $(this).data("autoslash-timepicker2-step");

        mobiscroll.time(input, {
            buttons: ['set'],
            display: 'bubble',
            steps: {
                minute: step
            },
            onInit: function (event, inst) {
                // inst.setVal(new Date(new Date().setHours(12, 0, 0, 0)));
                var currentText = input.val();
                applyMidnightHelper(input, currentText);
            },
            onChange: function (event, inst) {
                inst.setVal(event.valueText, true);
                applyMidnightHelper(input, event.valueText);
            },
            formatValue: function (data) {
                if (data[0] === 0 && data[1] == 0) {
                    if (data[2] === 1) {
                        return "Noon";
                    } else {
                        return "Midnight"
                    }
                } else {
                    return (data[0] === 0 ? "12" : data[0]) + ":" + data[1].toString().padStart(2, "0") + " " + (data[2] == 1 ? "PM" : "AM");
                }
            },
            parseValue: function (str) {
                if (!str) {
                    return [0, 0, 1];
                }

                if (typeof str.split === 'function') {
                    if (str === "Noon") {
                        return [0, 0, 1];
                    } else if (str === "Midnight") {
                        return [0, 0, 0];
                    } else { // parse standard time format i.e. "12:30 PM" into array
                        let res = str.split(" ");
                        let amPm = res[1] === "PM" ? 1 : 0;
                        let time = res[0].split(":");
                        let hour = (time[0] === "12" ? 0 : parseInt(time[0]));
                        let minute = parseInt(time[1]);
                        return [hour, minute, amPm];
                    }
                }
            }
        })
    });
}